export function buildCMSPageURL() {
  return '/website'
}
